export default __webpack_public_path__ + "static/media/steps-main.7c1442db.svg";